/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import { gnoment, Gnoment } from 'shared-ui/gnoment';
import PropTypes from 'prop-types';
import { FlexRow, FlexCol } from 'sarsaparilla';
import { readRuleValue } from '../../utils/utilsNew';

const propTypes = {
    permit: PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        rules: PropTypes.array,
    }).isRequired,
    entryDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Gnoment)]),
    exitDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Gnoment)]),
    incrementCheckoutDate: PropTypes.bool,
    isLottery: PropTypes.bool,
};

const defaultProps = {
    entryDate: '',
    exitDate: '',
    incrementCheckoutDate: false,
    isLottery: false,
};

export default class EntryExitDateText extends React.Component {
    render() {
        const entryDate = gnoment(this.props.entryDate).utc(true).format('LL');
        const exitDate = this.props.incrementCheckoutDate
            ? gnoment(this.props.exitDate).utc(true).add(1, 'day').format('LL')
            : gnoment(this.props.exitDate).utc(true).format('LL');

        const exitDateLabel =
            exitDate === 'Invalid date' ? (
                <div className="rec-dates-value">Date needed</div>
            ) : (
                <div className="rec-dates-value">{exitDate}</div>
            );

        return (
            <div className="rec-order-summary-item-dates">
                <FlexRow>
                    <FlexCol>
                        <div className="rec-dates-label">Entry Date</div>
                        <div className="rec-dates-value">{entryDate}</div>
                    </FlexCol>
                    {!readRuleValue('ShowEntryDateOnly', this.props.permit.rules) &&
                        !this.props.isLottery && (
                            // if no issuance provided OR if issuance provided, it is not part of lottery
                            <FlexCol>
                                <div className="rec-dates-label">Exit Date</div>
                                {exitDateLabel}
                            </FlexCol>
                        )}
                </FlexRow>
            </div>
        );
    }
}

EntryExitDateText.propTypes = propTypes;
EntryExitDateText.defaultProps = defaultProps;
